import { Grid } from '@mui/material';
import React from 'react';
import LabelWithIcon from '../../../common/ui/LabelWithIcon';
import FormInput from '../../../common/ui/Forms/FormInput/FormInput';
import PdfUpload from '../../../common/PdfUpload';
import { useTranslation } from 'react-i18next';

function Gst({
  control,
  register,
  errors,
  view = false,
  watch,
  setValue,
}: {
  control?: any;
  register: any;
  errors?: any;
  view?: boolean;
  watch: any;
  setValue: any;
}) {
  const { t } = useTranslation();
  return (
    <div>
      {' '}
      <Grid container display='flex' justifyContent='flex-start'>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6} p={2}>
          <LabelWithIcon
            label={t('GST_NO')}
            justifyContent='flex-start'
            className='mb-6  '
          />
          <FormInput
            name='gst_no'
            type='text'
            placeholder={t(`GST_NO`)}
            control={control}
            readOnly={view}
            className='input-from'
            rules={{
              required: {
                value: true,
                message: 'Please enter a GST no..',
              },
            }}
            inputProps={{
              ...register('gst_no', {}),
            }}
            errors={errors}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={6} p={2}>
          {' '}
          <LabelWithIcon
            label={t('Certificate date')}
            justifyContent='flex-start'
            className='mb-6 ml-3'
          />
          <FormInput
            name={`gst_Certificate_date`}
            type='date'
            placeholder='gst..'
            control={control}
            className='input-from'
            inputProps={{
              ...register(`gst_Certificate_date` as const),
            }}
            rules={{
              required: {
                value: true,
                message: t('SELECT_THE_CERTIFICATE_DATE'),
              },
            }}
            errorName={'gst_Certificate_date'}
            errors={errors}
            readOnly={view}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6} xl={6} p={2}>
          <PdfUpload
            control={control}
            register={register}
            errors={errors}
            watch={watch}
            setValue={setValue}
            name={`GST_certificate`}
            errorName={`GST_certificate`}
            secondName={`GST_certificate`}
            labelName={t('CERTIFICATE')}
            errorMessage={t('PLEASER_SELECT_THE_CERTIFICATE')}
          />
        </Grid>
      </Grid>
    </div>
  );
}
export default Gst;
